import React, { useState, useEffect } from 'react';
import { TYPES, TYPE_COLORS } from '../data/types';
import PlayingCard from '../components/PlayingCard';
import './Landing.css';

const BUBBLES = [
  { code:'INTJ', emoji:'🏛️' }, { code:'ENFP', emoji:'🦋' },
  { code:'INFJ', emoji:'🌿' }, { code:'ESTP', emoji:'🚀' },
  { code:'ISTJ', emoji:'🏗️' }, { code:'ENTP', emoji:'💡' },
  { code:'ISFP', emoji:'🌸' }, { code:'ENTJ', emoji:'⚡' },
];

export default function Landing({ onStart }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 80); }, []);

  return (
    <div className={`landing`} style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s' }}>

      {/* NAV */}
      <nav className="nav">
        <div className="logo-wrap">
          <span className="logo-text">
            <span className="logo-ich">ICH</span><span className="logo-type">TYPE</span><span className="logo-de">.DE</span>
          </span>
        </div>
        <div className="nav-right">
          <div className="nav-badge">
            <div className="nav-dot" />
            Kostenlos & Sofort
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-pill">
            <span className="pill-icon">🧠</span>
            Wissenschaftlich fundiert · A/B Format · 5 Minuten
          </div>

          <h1 className="hero-title">
            Wer bist du<br />
            <span className="highlight">wirklich?</span>
          </h1>

          <p className="hero-sub">
            Dein bisheriges MBTI-Ergebnis könnte falsch sein. Unser präziser A/B-Test
            deckt auf, was andere Tests verschweigen — dein echtes Persönlichkeitsprofil.
          </p>

          <p className="hero-claim">
            ✓ Einfach per A oder B beantworten &nbsp;·&nbsp; <span>✓ Kein langes Nachdenken nötig</span>
          </p>

          <div className="cta-group">
            <button className="btn-hero" onClick={onStart}>
              Meinen Typ entdecken
              <span className="btn-arrow">→</span>
            </button>
            <span className="cta-note">Keine Anmeldung · Ergebnis sofort · 100% kostenlos</span>
          </div>

          <div className="type-bubbles">
            {BUBBLES.map(b => {
              const c = TYPE_COLORS[b.code];
              return (
                <div key={b.code} className="type-bubble"
                  style={{ borderColor: c.border, background: c.bg }}>
                  <span className="bubble-emoji">{b.emoji}</span>
                  <span style={{ color: c.accent, fontWeight: 800 }}>{b.code}</span>
                  <span style={{ color: '#64748B', fontSize: 12, fontWeight: 600 }}>{TYPES[b.code].name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how-section">
        <div className="section-label">So funktioniert es</div>
        <h2 className="section-title">Einfacher als alle anderen Tests</h2>
        <p className="section-sub">
          Vergiss endlose Skalen und komplizierte Fragen. Bei ICHTYPE.DE wählst du immer nur zwischen A oder B — keine Graubereiche, keine Verwirrung.
        </p>
        <div className="steps">
          <div className="step">
            <div className="step-num">1</div>
            <h3>A oder B wählen</h3>
            <p>25 klare Fragen, immer zwei Antwortmöglichkeiten. Wähle instinktiv — dein erster Gedanke ist der ehrlichste.</p>
          </div>
          <div className="step">
            <div className="step-num">2</div>
            <h3>Ergebnis berechnen</h3>
            <p>Unser Algorithmus analysiert deine Antwortmuster und ordnet dich einem der 16 Persönlichkeitstypen zu.</p>
          </div>
          <div className="step">
            <div className="step-num">3</div>
            <h3>Bericht erhalten</h3>
            <p>Erhalte deinen vollständigen Persönlichkeitsbericht per E-Mail — Stärken, Schwächen, Karriere, Beziehungen.</p>
          </div>
        </div>
      </section>

      {/* A/B FORMAT DEMO */}
      <section className="ab-section">
        <div className="ab-inner">
          <div className="section-label">Das A/B-Format</div>
          <h2 className="section-title">Kein lästiges Schieberegler-Chaos</h2>
          <p className="section-sub">
            Andere Tests quälen dich mit 7-Punkte-Skalen. Wir nicht. Bei uns wählst du einfach A oder B — und kommst trotzdem zum präzisesten Ergebnis.
          </p>

          <div className="ab-demo">
            <div className="ab-question">❓ Wie verbringst du deinen freien Abend am liebsten?</div>
            <div className="ab-choices">
              <div className="ab-choice">
                <div className="ab-letter">A</div>
                <div className="ab-text">Mit Freunden ausgehen und den Abend in geselliger Runde verbringen</div>
              </div>
              <div className="ab-choice">
                <div className="ab-letter">B</div>
                <div className="ab-text">Zuhause bleiben, lesen oder einem Hobby nachgehen</div>
              </div>
            </div>
            <div className="ab-note">So einfach ist unser Test. Einfach A oder B — fertig ✓</div>
          </div>
        </div>
      </section>

      {/* ACCURACY / MARKETING */}
      <section className="accuracy-section">
        <div className="accuracy-grid">
          <div className="accuracy-claims">
            <div className="section-label" style={{textAlign:'left'}}>Warum ICHTYPE.DE?</div>
            <h2 className="section-title" style={{textAlign:'left', marginBottom:24}}>Dein altes MBTI-Ergebnis könnte falsch sein</h2>

            <div className="claim">
              <div className="claim-icon">🎯</div>
              <div>
                <h4>Höchste Präzision durch A/B-Methodik</h4>
                <p>Keine vagen Zwischenantworten die dein Ergebnis verfälschen. Klare Entscheidungen liefern klarere Ergebnisse.</p>
              </div>
            </div>
            <div className="claim">
              <div className="claim-icon">🔄</div>
              <div>
                <h4>Persönlichkeit verändert sich mit der Zeit</h4>
                <p>Dein Ergebnis von vor 5 Jahren spiegelt vielleicht nicht mehr wider, wer du heute bist. Teste es neu.</p>
              </div>
            </div>
            <div className="claim">
              <div className="claim-icon">🧬</div>
              <div>
                <h4>Basierend auf aktuellem Forschungsstand</h4>
                <p>Unser Fragenkatalog ist nach dem neuesten Stand der Persönlichkeitspsychologie aufgebaut.</p>
              </div>
            </div>
          </div>

          <div className="accuracy-stats">
            {[
              { num:'16', label:'Einzigartige Persönlichkeitstypen' },
              { num:'25', label:'Präzise A/B Fragen' },
              { num:'5min', label:'Durchschnittliche Testdauer' },
              { num:'100%', label:'Kostenlos & ohne Anmeldung' },
            ].map(s => (
              <div key={s.num} className="stat-card">
                <div className="stat-num">{s.num}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ALL 16 TYPES */}
      <section className="types-section">
        <div className="section-label">Alle 16 Typen</div>
        <h2 className="section-title">Welcher bist du?</h2>
        <p className="section-sub">Jeder der 16 Typen hat einzigartige Stärken. Mach den Test und finde deinen heraus.</p>

        <div className="types-grid">
          {Object.values(TYPES).map(t => (
            <div key={t.code} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6}}>
              <PlayingCard typeCode={t.code} size="medium" />
              <div style={{fontSize:12,fontWeight:700,color:'var(--text2)',textAlign:'center'}}>{t.name}</div>
            </div>
          ))}
        </div>
      </section>

      {/* FOOTER CTA */}
      <section className="footer-cta">
        <h2>Bereit, dich selbst zu entdecken?</h2>
        <p>25 Fragen. 5 Minuten. Eine Antwort, die alles erklärt.</p>
        <button className="btn-white" onClick={onStart}>
          Jetzt kostenlos testen →
        </button>
      </section>

      <footer className="page-footer">
        <p>© 2025 ICHTYPE.DE &nbsp;·&nbsp; <a href="/datenschutz">Datenschutz</a> &nbsp;·&nbsp; <a href="/impressum">Impressum</a> &nbsp;·&nbsp; <a href="/abbestellen">Abmelden</a></p>
      </footer>
    </div>
  );
}
